import { getFormattedTripDetails } from '@/pages/Trips/Trips.functions'
import { GetAllTripsForAdminData } from '@/redux/states/admin/trips/getAllTripsForAdmin/getAllTripsForAdmin.types'
import date, { dateTimeFormats } from '@/shared/functions/Date/date.functions'
import { getFormattedTripType } from '@/shared/functions/Flights/flights.functions'
import { TripType } from '@/shared/functions/Flights/flights.types'
import { FlightItineraryLeg } from '@/shared/functions/Places/places.types'
import { changeCase } from '@/shared/functions/String/string.functions'
import { Chip } from '@mui/material'

import { TableColumn } from '../../../../shared/components/Table/Table.types'
import { getStatusColor } from '../../../../shared/functions/Status/status.functions'
import { Trip } from './Trips.types'

export const tripTableColumns: TableColumn<GetAllTripsForAdminData['records'][number]>[] = [
  { key: 'id', label: 'Trip ID', render: (row: Trip) => row.flightItineraryDetails?.id },
  {
    key: 'traveler',
    label: 'Traveler',
    render: (row: Trip) =>
      `${row.flightItineraryDetails?.traveler.firstName} ${row.flightItineraryDetails?.traveler.lastName}`
  },
  {
    key: 'travelerEmail',
    label: 'Email',
    render: (row: Trip) => row.flightItineraryDetails?.traveler.email
  },
  {
    key: 'tripType',
    label: 'Trip Type',
    render: (row: Trip) => getFormattedTripType(row.flightItineraryDetails?.tripType as TripType)
  },
  {
    key: 'tripDetails',
    label: 'Trip Details',
    render: (row: Trip) =>
      getFormattedTripDetails(
        row.flightItineraryDetails?.legs as unknown as FlightItineraryLeg[],
        row.flightItineraryDetails?.tripType as TripType,
        true
      )
  },
  {
    key: 'tripDate',
    label: 'Trip Date',
    render: (row: Trip) => {
      const firstLeg = row.flightItineraryDetails?.legs[0]
      const lastLeg = row.flightItineraryDetails?.legs[row.flightItineraryDetails?.legs.length - 1]

      return firstLeg && lastLeg
        ? `${date(firstLeg.travelDate).format(dateTimeFormats.date.short)} - ${date(lastLeg.travelDate).format(dateTimeFormats.date.short)}`
        : '-'
    }
  },
  {
    key: 'itinerarySource',
    label: 'Booking Type',
    render: (row: Trip) => changeCase(row.flightItineraryDetails?.itinerarySource).sentence
  },
  {
    key: 'confirmationCode',
    label: 'Confirmation Code',
    render: (row: Trip) => row.flightBookingDetails?.confirmationCode ?? '-'
  },
  {
    key: 'tripStatus',
    label: 'Trip Status',
    render: (row: Trip) => (
      <Chip
        label={row.flightItineraryDetails?.status.displayName}
        color={getStatusColor(row.flightItineraryDetails?.status.name)}
      />
    )
  }
]
